import {Component, Input, OnInit} from '@angular/core';
import {EnrollCabinet} from '../../../model/enroll-cabinet';
import {LangChange} from '../../../../../../lang-change';
import {TranslateService} from '@ngx-translate/core';
import {Language} from '../../../../../../common/models/language';
import {CenterSpecialization} from '../../../../../../common/dtos/center-specialization';
import {EnrollCommissionDecision} from '../../../model/enroll-commission-decision';
import {EnrollApplicationService} from '../../../../../common-main/services/enroll-application.service';
import {CollegeInfoService} from '../../../../../common-main/services/college-info.service';
import {Utils} from '../../../../../../common/services/Utils';
import {CenterProfessionService} from '../../../../../../common_services/center-profession.service';
import {AlternativeCollegeItem} from '../enroll-entrans-info/model/alternative-college-item';
import {EnrollCommissionDecisionService} from '../../../../services/enroll-commission-decision.service';

@Component({
  selector: 'app-enroll-commission-decision',
  templateUrl: './enroll-commission-decision.component.html',
  styleUrls: ['./enroll-commission-decision.component.scss']
})
export class EnrollCommissionDecisionComponent extends LangChange implements OnInit {
  decision: EnrollCommissionDecision = new EnrollCommissionDecision();
  savedDecision: EnrollCommissionDecision = new EnrollCommissionDecision();
  @Input() public data: EnrollCabinet;
  @Input() public dics: any;
  @Input() public isTechSecretary: boolean;
  @Input() public isUniversityWorker: boolean;
  alternativeColleges: AlternativeCollegeItem[];
  formIsDisabled = true;
  professions: any[] = [];
  qualifications: CenterSpecialization[];
  colleges: any[] = [];
  public errors: any = [];

  constructor(public utils: Utils,
              public translateService: TranslateService,
              private _enrollApplicationService: EnrollApplicationService,
              private _centerProfessionService: CenterProfessionService,
              private _collegeInfoService: CollegeInfoService,
              private _decisionService: EnrollCommissionDecisionService) {
    super(translateService);

  }

  onLangChange(language: Language): void {
  }

  @Input() set _alternativeColleges(alternativeColleges: AlternativeCollegeItem[]) {
    this.alternativeColleges = alternativeColleges;
    this.loadCenterProfession(null);
  }

  ngOnInit() {
    this.checkFormDisabled();
    this.setDecisionDefaultValues();
    this.loadCenterProfession(null);
  }

  checkFormDisabled() {
    if (this.data.finalGrant !== null) {
      if (this.data.finalGrant == -1) {
        this.formIsDisabled = !this.isTechSecretary;
      } else if (this.data.finalGrant >= 0) {
        this.formIsDisabled = !(this.isTechSecretary && !this.isUniversityWorker);
      }
    } else {
      this.formIsDisabled = !this.data.entrance_info.mustBeDecidedByCommission;
    }
  }

  setDecisionDefaultValues() {
    this.decision.educated = this.data.edu_info.edu_received || 0;
    this.decision.lang = this.data.entrance_info.learn_lang || 0;
    this.decision.mustBeDecidedByCommission = this.data.entrance_info.mustBeDecidedByCommission;
    if (this.data.finalGrant != null && this.data.finalGrant == 0) {
      this.decision.speciality = this.data.entrance_info.speciality || 0;
      this.decision.qualification = this.data.entrance_info.qualification || 0;
      this.decision.collegeId = this.data.collegeId || 0;
    } else if (this.data.finalGrant > 0 && this.data.finalGrant <= 3) {
      this.alternativeColleges.forEach(c => {
        if (c.number == this.data.finalGrant) {
          this.decision.speciality = c.specId || 0;
          this.decision.qualification = c.qualificationId || 0;
          this.decision.collegeId = c.collegeId || 0;
        }
      });
    } else if (this.data.finalGrant == 100) {
      if (this.savedDecision.id == 0) {
        this._decisionService.getConfirmedCommissionDecision(this.data.enrollId).subscribe(response => {

          this.savedDecision = Object.assign(this.savedDecision, response.data);
          this.decision = Object.assign(this.decision, response.data);
          this.loadCenterProfession(null);
        });
      } else {
        this.decision.lang = this.savedDecision.lang;
        this.decision.speciality = this.savedDecision.speciality;
        this.decision.qualification = this.savedDecision.qualification;
        this.decision.collegeId = this.savedDecision.collegeId;
      }
    }
  }

  loadCenterProfession(event) {
    if (event) {
      this.decision.speciality = 0;
      this.professions = [];
    }
    const filter = {
      hasCount: true,
      studyLanguageId: this.decision.lang,
      educatedId: this.data.edu_info.edu_received
    };
    if (this.decision.lang && this.data.edu_info.edu_received) {
      this._centerProfessionService.getCenterProfessionsWithGrant(filter).subscribe(data => {
          this.professions = this.utils.translateListWithSort(data, 'name');
          this.professions.map((i) => {
            i.fullName = i.code + ' ' + i.name;
            return i;
          });
          if (!event) {
            this.setDecisionDefaultValues();
          }
          this.loadQualification(event);
        }, err => {
          console.log('loadCenterProfession() error', err);
          this.utils.notifyError(this._translateService.instant('error_occurred'), '');
        }
      );
    }
  }

  loadQualification(event) {
    if (event) {
      this.decision.qualification = 0;
      this.qualifications = [];
    }
    if (!!this.decision && this.decision.speciality > 0) {
      const filter = {
        centerProfessionId: this.decision.speciality,
        educatedId: this.data.edu_info.edu_received,
        studylanguageId: this.decision.lang,
        isUsedInGrant: true,
        status: 5,
        year: new Date().getFullYear()
      };
      this._enrollApplicationService.getCenterSpecializations(filter).subscribe(data => {
        this.qualifications = data;
        Language.updateListLocalizedName(this.qualifications);
        this.qualifications.map((i) => {
          i.name = i.code + ' ' + i.name;
          return i;
        });
        if (!event) {
          this.setDecisionDefaultValues();
        }
        this.loadColleges(event);
      });
    } else {
      this.loadColleges(event);
    }
  }

  loadColleges(event) {
    if (event) {
      this.decision.collegeId = 0;
      this.colleges = [];
    }
    if (this.decision.speciality > 0 && this.decision.qualification > 0 && this.data.entrance_info.payment_form > 0) {
      this._collegeInfoService.getCollegesWithGrant(this.decision.speciality, this.decision.qualification, this.data.edu_info.edu_received,
        this.decision.lang, this.utils._translateService.currentLang, this.data.entrance_info.payment_form).subscribe(
        response => {
          this.colleges = response['colleges'];
          if (!event) {
            this.setDecisionDefaultValues();
          }
        },
        error => console.log(error)
      );
    }
  }

  confirmDecision() {
    if (this.formIsDisabled) {
      return;
    }
    if (this.validateForm()) {
      this._decisionService.checkForFreeGrantPlaces(this.decision).subscribe(response => {
        console.log(response);
        if (response.data) {
          this.utils.confirmDialog({
            message: 'enroll_application_operations.commission_decision.confirm_dialog',
            messageParams: this.getConfirmMessageParams()
          }, () => {
            this._decisionService.confirmDecision(this.data.enrollId, this.decision).subscribe(value => {
              if (value.data.id) {
                this.data.finalGrant = 100;
                this.decision.id = value.data.id;
                this.decision.confirmedTime = value.data.confirmedTime;
                this.savedDecision = value.data;
                this.checkFormDisabled();
                this.utils.notifySuccess(this._translateService.instant('saved'), null);
              } else {
                this.utils.notifyError('error_occurred', '');
                console.log(value);
              }
            }, error => {
              this.utils.notifyError('error_occurred', '');
            });
          });
        } else {
          this.errors.push('enroll_application_operations.commission_decision.no_grants_for_qualification');
        }
      }, error => {
        this.utils.notifyError('error_occurred', '');
      });

    }
  }

  getConfirmMessageParams() {
    let speciality = '';
    let qualification = '';
    let language = '';
    let college = '';
    this.professions.forEach(p => {
      if (p.id == this.decision.speciality) {
        speciality = p.fullName;
      }
    });
    this.qualifications.forEach(q => {
      if (q.id == this.decision.qualification) {
        qualification = q.name;
      }
    });
    this.dics.language.forEach(l => {
      if (l.id == this.decision.lang) {
        language = l.name;
      }
    });
    this.colleges.forEach(c => {
      if (c.id == this.decision.collegeId) {
        college = c.name;
      }
    });
    return {
      applicantFullName: this.data.personal_info.fullName,
      code_speciality: speciality,
      code_qualification: qualification,
      language: language,
      college: college
    };
  }

  cancelConfirmedDecision() {
    console.log('formIsDisabled', this.formIsDisabled);
    console.log('decision', this.decision);
    console.log('savedDecision', this.savedDecision);
    console.log('altColleges: ', this.alternativeColleges);
    console.log('enroll: ', this.data);
    /*
        this.utils.confirmDialog({message: 'Вы уверены, что хотите присвоить ...'}, () => {
          this._decisionService.cancelDecision(this.data.enrollId, this.decision).subscribe(data => {
            this.data.finalGrant = data.finalGrant; // previous final grant
            this.utils.notifySuccess(this._translateService.instant('deleted_success'), null);
            console.log(data);
          }, error => {
            this.utils.notifyError('error_occurred', '');
          });
        });
    */
  }

  validateForm() {
    this.errors = [];
    if (!this.decision.speciality || !this.decision.qualification || !this.decision.lang || !this.decision.collegeId) {
      this.errors.push('fill_in_all');
    }
    if (this.data.finalGrant != null && this.data.finalGrant >= 0) {
      const grantDecision = new EnrollCommissionDecision();
      if (this.data.finalGrant == 0) {
        grantDecision.lang = this.data.entrance_info.learn_lang;
        grantDecision.speciality = this.data.entrance_info.speciality;
        grantDecision.qualification = this.data.entrance_info.qualification;
        grantDecision.collegeId = this.data.collegeId;
      } else if (this.data.finalGrant > 0 && this.data.finalGrant <= 3) {
        this.alternativeColleges.forEach(c => {
          if (c.number == this.data.finalGrant) {
            grantDecision.lang = this.data.entrance_info.learn_lang;
            grantDecision.speciality = c.specId;
            grantDecision.qualification = c.qualificationId;
            grantDecision.collegeId = c.collegeId;
          }
        });
      } else if (this.data.finalGrant == 100) {
        grantDecision.lang = this.savedDecision.lang;
        grantDecision.speciality = this.savedDecision.speciality;
        grantDecision.qualification = this.savedDecision.qualification;
        grantDecision.collegeId = this.savedDecision.collegeId;
      }
      if (this.decision.lang == grantDecision.lang
        && this.decision.speciality == grantDecision.speciality
        && this.decision.qualification == grantDecision.qualification
        && this.decision.collegeId == grantDecision.collegeId) {
        let collegeName = '';
        this.colleges.forEach(c => {
          if (c.id == this.decision.collegeId) {
            collegeName = c.name;
          }
        });
        const param = {college: collegeName};
        this._translateService.get('enroll_application_operations.commission_decision.already_granted', param).subscribe((res: string) => {
          this.errors.push(res);
        });
      }
    }
    return this.errors.length == 0;
  }

  getHeaderMessage() {
    let message = '';
    const param = {name: this.data.personal_info.fullName};
    this._translateService.get('enroll_application_operations.commission_decision.confirmed_grant', param).subscribe((res: string) => {
      message = res;
    });
    return message;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-commission-decision/enroll-commission-decision.component.ts